module.exports = __webpack_public_path__ + "img/img_verified_idphoto_b.4fad10d4.png";